import { newDate } from 'helpers/date-time';
import { cloneDeep, isBoolean } from 'lodash';
import types from 'redux/types';

const initialState = {
  open: false,
};

export default (state = initialState, actions) => {
  switch (actions.type) {
    case types.TOGGLE_BACKGROUND_PROCESS: {
      const nextState = cloneDeep(state);

      if (isBoolean(actions.open)) {
        nextState.open = actions.open;
      } else {
        nextState.open = !nextState.open;
      }

      nextState.processingId = newDate().getTime();

      return nextState;
    }

    default:
      return state;
  }
};
